import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';
import investmentFilterLang from '../../../langs/investmentFilterLang';

type CFiltersInvestmentYearSelectProps = {
	optionsInvestmentYears: { id: number; name: string }[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
};

const CFiltersInvestmentYearSelect = (props: CFiltersInvestmentYearSelectProps) => {
	const { optionsInvestmentYears, filters, onChange } = props;

	const { t } = useTranslation();

	return (
		<CAppFilterSelect
			className="filter-investmentYear"
			label={t(investmentFilterLang.investment_year.tag)}
			value={
				filters && filters.investmentYear
					? optionsInvestmentYears.find((x) => x.id === filters.investmentYear)
					: null
			}
			onChange={(val: { id: number; name: string }) =>
				onChange({
					...filters,
					investmentYear: val ? val.id : null,
				})
			}
			size="small"
			options={optionsInvestmentYears}
		/>
	);
};

export default CFiltersInvestmentYearSelect;
